// extracted by mini-css-extract-plugin
module.exports = {"bannerSpacing":"slackid-onboarding-modal_bannerSpacing_2uF"};